/**
 * Column labels above the compare grid (Plans / Free / Elite / Prime).
 * Isolated so header copy and column widths stay aligned with availability cells.
 */

export function ElitePlansCompareColumnHeaders() {
  return (
    <div className='flex items-center justify-between px-1'>
      <p className='text-sm font-normal text-[#8E9393]'>Plans</p>
      <div className='flex items-center gap-[29px] pr-1'>
        <span className='w-10 text-center text-sm font-medium text-[#6A6E6E]'>Free</span>
        <span className='w-10 text-center text-sm font-bold text-[#CC5C2D]'>Elite</span>
        <span className='w-10 text-center text-sm font-bold text-[#C4515D]'>Prime</span>
      </div>
    </div>
  )
}
